import Swiper from 'swiper/dist/js/swiper.min';

const Swipers = {};

Swipers.tile_swiper = new Swiper('.tiles-slider', {
    loop: false,
    slidesPerView: 4,
    freeMode: false,
    pagination: {
        el: '.slider__progress',
        type: 'progressbar',
    },
    navigation: {
        nextEl: '.slider__navigation-button--next-' + i,
        prevEl: '.slider__navigation-button--prev-' + i,
    },
    breakpoints: {
        1024: {
            slidesPerView: 3
        },
        768: {
            slidesPerView: 2
        },
        640: {
            slidesPerView: 1
        }
    },
    speed: 400
});

let i;
for (i = 1; i < 11; i++) {
    Swipers.tile_photo_swiper = new Swiper('.tiles-photo-slider-' + i, {
        loop: false,
        slidesPerView: 2,
        freeMode: false,
        pagination: {
            el: '.slider__progress-count-' + i,
            type: 'progressbar',
        },
        navigation: {
            nextEl: '.slider__navigation-button--next-' + i,
            prevEl: '.slider__navigation-button--prev-' + i,
        },
        breakpoints: {
            1023: {
                slidesPerView: 2
            },
            991: {
                slidesPerView: 1
            },
            768: {
                slidesPerView: 1,
            }
        },
        speed: 400
    });

    Swipers.tile_article_image_swiper = new Swiper('.tiles-article-image-' + i, {
        loop: false,
        slidesPerView: 1,
        freeMode: false,
        spaceBetween: 80,
        pagination: {
            el: '.slider__progress-count-' + i,
            type: 'progressbar',
        },
        navigation: {
            nextEl: '.slider__navigation-button--next-' + i,
            prevEl: '.slider__navigation-button--prev-' + i,
        },
        speed: 400
    });

    Swipers.image_swiper = new Swiper('.image-slider-' + i, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 32,
        freeMode: false,
        navigation: {
            nextEl: '.slider__navigation-button--next-' + i,
            prevEl: '.slider__navigation-button--prev-' + i,
        },
        speed: 600,
    });

    Swipers.tile_swipers_flex = new Swiper('.tiles-slider-' + i, {
        loop: false,
        slidesPerView: 4,
        freeMode: false,
        pagination: {
            el: '.slider__progress-' + i,
            type: 'progressbar',
        },
        navigation: {
            nextEl: '.slider__navigation-button-in-4--next-' + i,
            prevEl: '.slider__navigation-button-in-4--prev-' + i,
        },
        breakpoints: {
            1024: {
                slidesPerView: 3
            },
            768: {
                slidesPerView: 2
            },
            640: {
                slidesPerView: 1
            }
        },
        speed: 400
    });
}

// Interatives sliders
Swipers.ia_bg_swiper = new Swiper('.ia-sliders__bg-slider', {
    loop: true,
    slidesPerView: 1,
    freeMode: false,
    speed: 1000,
    effect: 'fade',
    simulateTouch: false,
    fadeEffect: {
        crossFade: true
    },
    navigation: {
        nextEl: '.ia-sliders__nav-button--next',
        prevEl: '.ia-sliders__nav-button--prev',
    },
});

Swipers.ia_content_swiper = new Swiper('.ia-sliders__content-slider', {
    loop: true,
    slidesPerView: 'auto',
    freeMode: false,
    simulateTouch: false,
    speed: 600,
    navigation: {
        nextEl: '.ia-sliders__nav-button--next',
        prevEl: '.ia-sliders__nav-button--prev',
    },
});

Swipers.ia_icon_swiper = new Swiper('.ia-sliders__icon-slider', {
    loop: true,
    slidesPerView: 'auto',
    freeMode: false,
    simulateTouch: false,
    centeredSlider: true,
    speed: 600,
    navigation: {
        nextEl: '.ia-sliders__nav-button--next',
        prevEl: '.ia-sliders__nav-button--prev',
    },
});

Swipers.product_thumb_slider = new Swiper('.product__thumb-slider', {
    spaceBetween: 8,
    slidesPerView: 'auto',
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
});

Swipers.product_image_slider = new Swiper('.product__image-slider', {
    loop: false,
    slidesPerView: 1,
    speed: 600,
    thumbs: {
        swiper: Swipers.product_thumb_slider
    },
    breakpoints: {
        767: {
            autoHeight: true
        },
    }
});

window.Swipers = Swipers;
